import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_IntakeReferralForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GENERAL_IntakeReferralForm' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    As a member, parent, or legal guardian of a member of  <input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only w-200 custom-add-only' />, you can expect to be instructed or given written information regarding the following, upon admission to  <input type='text' id='txtProviderName_2' name='txtProviderName_2' className='add-only w-200 custom-add-only' /> Mental Health Program.
                </p>
                <p className='w-750'>
                    <ol>
                        <li>
                            Member Rights & Responsibilities
                        </li>
                        <li>
                            Grievance and Appeal Procedures
                        </li>
                        <li>
                            Communication/input policies regarding:
                            <ol type="a">
                                <li>
                                    Quality of Care
                                </li>
                                <li>
                                    Outcome Achievement.
                                </li>
                                <li>
                                    Member Satisfaction
                                </li>
                            </ol>
                        </li>
                        <li>
                            Explanation of  <input type='text' id='txtProviderName_3' name='txtProviderName_3' className='add-only w-200 custom-add-only' />
                            <ol type="a">
                                <li>
                                    Mission/Philosphy
                                </li>
                                <li>
                                    Services, activities, and therapentic interventions
                                </li>
                                <li>
                                    Expectations
                                </li>
                                <li>
                                    Hours of Operation
                                </li>
                                <li>
                                    24-Hour On Call Policy
                                </li>
                                <li>
                                    code of Ethics
                                </li>
                                <li>
                                    Confidentiality Policy
                                </li>
                                <li>
                                    Requirements for follow-up for mandated members, regardless of his/her discharge outcome.
                                </li>
                            </ol>
                        </li>
                        <li>
                            Explanation of any and all financial obligations, fees, and arrangements for services provided by the organization.
                        </li>
                        <li>
                            Orientation with  <input type='text' id='txtProviderName_4' name='txtProviderName_4' className='add-only w-200 custom-add-only' /> facilities, including emergency exits, fire suppression equipment, and first aid kits.
                        </li>
                        <li>
                            <input type='text' id='txtProviderName_5' name='txtProviderName_5' className='add-only w-200 custom-add-only' /> policies regarding:
                            <ol type="a">
                                <li>
                                    Smoking
                                </li>
                                <li>
                                    Illicit or ficit drugs
                                </li>
                                <li>
                                    Weapons
                                </li>
                                <li>
                                    Abuse
                                </li>
                            </ol>
                        </li>
                        <li>
                            Identification of service coordinator.
                        </li>
                        <li>
                            Program rules that identify:
                            <ol type="a">
                                <li>
                                    Any restrictions the program may place on members.
                                </li>
                                <li>
                                    Events, behaviors, or attitudes that may lend to the loss of rights or privileges for the member.
                                </li>
                                <li>
                                    Means by which the member may regain, rights or privileges that have been restricted.
                                </li>
                            </ol>
                        </li>
                        <li>
                            Education regarding Advanced Directives, where appropriate.
                        </li>
                        <li>
                            Identification of the purpose and precess of assessment.
                        </li>
                        <li>
                            A description of how the Treatment Plan will be developed.
                        </li>
                        <li>
                            Information regarding transition criteria and procedures.
                        </li>
                    </ol>

                </p>
                <table>
                    <tr>
                        <td className='w-500 signature'> &nbsp; </td>
                        <td className='w-250 signature'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small'> Client/Legal Guardian Signature </td>
                        <td className='small'> Date </td>
                    </tr>
                    <tr>
                        <td className='w-500 signature'> &nbsp; </td>
                        <td className='w-250 signature'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small'> Signature  </td>
                        <td className='small'> Date  </td>
                    </tr>
                </table>
            </div>
        </form>

    )
}